/* eslint-disable import/prefer-default-export */
import cn from 'classnames'
import { FC } from 'react'

import Button from '../Button'
import Text from '../Text'
import styles from './Toast.module.scss'
import { ToastContainer } from './ToastContainer'
import CloseIcon from './lib/icons/close.svg'
import ErrorIcon from './lib/icons/error.svg'
import SuccessIcon from './lib/icons/success.svg'
import { ToastInputProps } from './lib/types'

import { Theme } from '~generated/types'
import useTheme from '~lib/theme/useTheme'

const Toast: FC<ToastInputProps> = ({ title, variant = 'default', before, content, after, links, onClose }) => {
  const [theme] = useTheme()
  return (
    <div className={cn(styles.root, variant && styles[variant], theme === Theme.DARK ? styles.dark : styles.light)}>
      <div>
        {variant === 'success' && <SuccessIcon className={styles.successIcon} />}
        {variant === 'error' && <ErrorIcon className={styles.errorIcon} />}
      </div>

      <div className={styles.main}>
        <div className={styles.title}>{title}</div>

        <div className={styles.content}>
          {before}
          <Text variant="secondary" textType="body-sm">
            {content}
          </Text>
          {after}
        </div>

        {links && (
          <div className={styles.footer}>
            {links.map(({ name, onClick }, index) => (
              <Button key={index.toString()} type="button" variant="link" onClick={onClick}>
                {name}
              </Button>
            ))}
          </div>
        )}
      </div>

      <div>
        <button type="button" className={styles.button} onClick={onClose}>
          <CloseIcon />
        </button>
      </div>
    </div>
  )
}

export default Object.assign(Toast, {
  Container: ToastContainer,
})
